import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export function ProSmallIcon(props: IconSvgProps) {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.98593 5.18797C4.39393 5.18797 5.32993 6.03597 5.32993 7.28397C5.32993 8.49197 4.36993 9.29197 2.92193 9.29997L2.27393 9.30797V10.812H0.929932V5.18797H2.98593ZM2.90593 8.10797C3.62593 8.10797 3.96193 7.66797 3.96193 7.25997C3.96193 6.83597 3.60993 6.37197 2.90593 6.37197H2.27393V8.10797H2.90593Z"
        fill={props.color}
      />
      <path
        d="M10.7807 10.812H9.21268L8.18868 9.30797H7.49268V10.812H6.14868V5.18797H8.24468C9.66068 5.18797 10.5887 6.04397 10.5887 7.27597C10.5887 8.05997 10.1967 8.67597 9.52468 9.01197L10.7807 10.812ZM7.49268 6.35597V8.13997H8.14068C8.77268 8.13997 9.18868 7.80397 9.18868 7.27597C9.18868 6.73197 8.78068 6.35597 8.13268 6.35597H7.49268Z"
        fill={props.color}
      />
      <path
        d="M14.1021 10.884C12.3741 10.884 11.1101 9.62797 11.1101 8.01197C11.1101 6.37197 12.3741 5.11597 14.1021 5.11597C15.8141 5.11597 17.0701 6.33997 17.0701 8.01197C17.0701 9.65997 15.8141 10.884 14.1021 10.884ZM14.1021 9.64397C15.0221 9.64397 15.6941 8.93997 15.6941 8.01197C15.6941 7.06797 15.0221 6.36397 14.1021 6.36397C13.1661 6.36397 12.4861 7.07597 12.4861 8.01197C12.4861 8.93197 13.1661 9.64397 14.1021 9.64397Z"
        fill={props.color}
      />
    </svg>
  )
}
